import React from 'react';
import TableHeader from '@/components/TableHeader';
import MainTable from './components/MainTable';
import useReactRouter from 'atv-use-react-router';

import styles from './index.module.scss';

function LiveList() {
  const { history } = useReactRouter();
  const handleAddBtnClick = () => {
    history.push('/lives/new');
  };
  return (
    <div className={styles.page}>
      <TableHeader name="直播" onAddBtnClick={handleAddBtnClick} />
      <div className={styles.mainTable}>
        <MainTable />
      </div>
    </div>
  );
}

export default LiveList;
